import { render, staticRenderFns } from "./EmailRichEditor.vue?vue&type=template&id=7270594a&scoped=true&"
import script from "./EmailRichEditor.vue?vue&type=script&lang=js&"
export * from "./EmailRichEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailRichEditor.vue?vue&type=style&index=0&id=7270594a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270594a",
  null
  
)

export default component.exports